export interface AppAccessSubPermission {
  moduleId: string;
  action: string;
  attributes?: string;
  isCheck: boolean;
}

export interface PermissionModule {
  module: string;
  route?: string;
  sub: AppAccessSubPermission[];
}

export function hasAppAccess(
  permissions: PermissionModule[] | undefined,
  moduleId: string,
): boolean {
  const module = permissions?.find((p) => p.module === "app-access");
  return !!module?.sub?.some((s) => s.moduleId === moduleId && s.isCheck);
}

export function getAccessibleAppsCount(
  permissions: PermissionModule[] | undefined,
): number {
  const module = permissions?.find((p) => p.module === "app-access");
  return module?.sub?.filter((s) => s.isCheck).length ?? 0;
}
